import { useMutation } from '@tanstack/react-query';
import { setAxiosAuth } from 'utils';
import { postSign } from 'core/api/customers/customer.api';

export const usePostSign = ({ accessToken = '' }) => {
  setAxiosAuth(accessToken);

  return useMutation({
    mutationFn: postSign,
    retry: 0,
  });
}
